import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import AppInput from '../../common/AppInput';
import ReCAPTCHA from '../../common/ReCaptcha';
import LoadingButton from '../../common/LoadingButton';
import MotiveTitle from '../../views/Contact/Motive/MotiveTitle';
import { RADIO_OPTIONS, PREFORM_FIELDS } from './validation/fields';
import { usePreFormRClubes } from './styles';
import {
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
} from '@material-ui/core';
import { textMapper } from '../../../helpers/FormHelper';
import {
  setMotiveId,
  setRut,
  setCodeClubes,
} from '../../../redux/slices/IssuesSlice';
import { setIsValidReCaptcha } from '../../../redux/slices/reCaptchaSlice';
import { setAuthorized } from '../../../redux/slices/RoutesAuthSlice';
import { CHOOSE_OPTION } from '../../../constants/texts';
import { schema } from './validation/schema';

const Form = ({ ...props }) => {
  const { state, onData, mobile, valid, motiveId } = props;
  const classes = usePreFormRClubes();
  const [valueRadioOptions, setValueRadioOptions] = useState('');
  const history = useHistory();
  const dispatch = useDispatch();
  const { reCaptchaToken, isValidReCaptcha } = useSelector(
    (state) => state.reCaptchaSlice,
  );
  const [showOcCaptcha, setShowOcCaptcha] = useState(false);

  const handleChange = (e) => {
    onData({ name: e.target.name, value: e.target.value });
    if (e.target.name === 'rut') dispatch(setRut(e.target.value));
    if (e.target.name === 'codeClubes') dispatch(setCodeClubes(e.target.value));

    let fieldsValidate = schema.validate({ [e.target.name]: e.target.value });
    if ('error' in fieldsValidate) {
      setShowOcCaptcha(false);
      resetCaptcha();
    } else setShowOcCaptcha(true);
  };

  const resetCaptcha = () => {
    dispatch(setIsValidReCaptcha(false));
  };

  const onChange = (e) => {
    setValueRadioOptions(e.target.value);
    dispatch(setMotiveId(e.target.value));
  };

  const onClick = () => {
    dispatch(setAuthorized(true));
    history.push(textMapper.get(motiveId).redirect);
  };

  return (
    <React.Fragment>
      {mobile && (
        <MotiveTitle
          icon={textMapper.get(motiveId).icon}
          title={textMapper.get(motiveId).title}
          subtitle={textMapper.get(motiveId).subtitle}
          mobile={mobile}
        />
      )}
      <Typography className={classes.title}>{CHOOSE_OPTION}</Typography>
      <RadioGroup onChange={onChange} value={valueRadioOptions}>
        {RADIO_OPTIONS.map((field, index) => (
          <FormControlLabel
            key={index}
            control={
              <Radio
                color="primary"
                data-cy={`radio${field.label.split(' ').join('')}`}
              />
            }
            label={field.label}
            value={field.id}
          />
        ))}
        {PREFORM_FIELDS.map((field, index) => (
          <AppInput
            key={index}
            onChange={handleChange}
            onBlur={() => {}}
            onClick={() => {}}
            disabled={state[field.name]?.disabled || false}
            name={field.name}
            error={state[field.name]?.error || false}
            type={state[field.name]?.type || ''}
            label={state[field.name]?.label || ''}
            required={state[field.name]?.required || false}
            inputAdornment={state[field.name]?.inputAdornment || ''}
            success={state[field.name]?.success || ''}
            helperText={state[field.name]?.helper || ''}
            multiline={state[field.name]?.multiline || false}
            rows={state[field.name]?.rows || ''}
            value={state[field.name]?.value || ''}
            errorMessage={state[field.name]?.message || ''}
          />
        ))}
        {showOcCaptcha && (
          <React.Fragment>
            <ReCAPTCHA />
            <LoadingButton
              className={classes.button}
              onClick={onClick}
              name="PreFormRClubes"
              variant="contained"
              color="primary"
              text="Continuar"
              disabled={
                !valid ||
                !isValidReCaptcha ||
                valueRadioOptions.length === 0 ||
                reCaptchaToken.length === 0
              }
            />
          </React.Fragment>
        )}
      </RadioGroup>
    </React.Fragment>
  );
};

Form.propTypes = {
  state: PropTypes.object,
  onData: PropTypes.func,
  mobile: PropTypes.bool,
  valid: PropTypes.bool,
  motiveId: PropTypes.string,
};

export default Form;
